import { axiosAuthInstance } from "./axiosAuth";
import { createApiError } from "./apiErrorHandler";

const base_url = import.meta.env.VITE_API_ENDPOINT;

export const listSubDistributorGroups = async () => {
  try {
    const url = `${base_url}/app/sub-distributor-groups`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "listSubDistributorGroups");
  }
};

export const getSubDistributorGroup = async (id) => {
  try {
    const url = `${base_url}/app/sub-distributor-groups/${id}`;
    const { data } = await axiosAuthInstance.get(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "getSubDistributorGroup", { id });
  }
};

export const createSubDistributorGroup = async (groupData) => {
  try {
    const url = `${base_url}/app/sub-distributor-groups`;
    const { data } = await axiosAuthInstance.post(url, groupData);
    return data;
  } catch (ex) {
    return createApiError(ex, "createSubDistributorGroup");
  }
};

export const updateSubDistributorGroup = async (id, groupData) => {
  try {
    const url = `${base_url}/app/sub-distributor-groups/${id}`;
    const { data } = await axiosAuthInstance.put(url, groupData);
    return data;
  } catch (ex) {
    return createApiError(ex, "updateSubDistributorGroup", { id });
  }
};

export const deleteSubDistributorGroup = async (id) => {
  try {
    const url = `${base_url}/app/sub-distributor-groups/${id}`;
    const { data } = await axiosAuthInstance.delete(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "deleteSubDistributorGroup", { id });
  }
};

export const addSubDistributorGroupMember = async (id, distributor_sub_distributor_id) => {
  try {
    const url = `${base_url}/app/sub-distributor-groups/${id}/members`;
    const { data } = await axiosAuthInstance.post(url, { distributor_sub_distributor_id });
    return data;
  } catch (ex) {
    return createApiError(ex, "addSubDistributorGroupMember", { id, distributor_sub_distributor_id });
  }
};

export const removeSubDistributorGroupMember = async (id, distributor_sub_distributor_id) => {
  try {
    const url = `${base_url}/app/sub-distributor-groups/${id}/members/${distributor_sub_distributor_id}`;
    const { data } = await axiosAuthInstance.delete(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "removeSubDistributorGroupMember", { id, distributor_sub_distributor_id });
  }
};

// Note: Group manager role is added via the standard addAppUserRoles API
// from megs-api-api.js with role: "group_manager" and sub_distributor_group_id

export const removeGroupManager = async (id, userId) => {
  try {
    const url = `${base_url}/app/sub-distributor-groups/${id}/managers/${userId}`;
    const { data } = await axiosAuthInstance.delete(url);
    return data;
  } catch (ex) {
    return createApiError(ex, "removeGroupManager", { id, userId });
  }
};
